import { gql } from '@apollo/client'

export const INSURANCE_QUERY = gql`
  query insurance($id: ID!) {
    insurance(id: $id) {
      id
      title
      policyNumberRegex
    }
  }
`
